import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.updateChartOrder.loading;
export const selectErrorMessage = (state: RootState) =>
  state.updateChartOrder.error;
export const updateChartOrderResponse = (state: RootState) =>
  state.updateChartOrder.updateChartOrderResponse;
